<template>
  <v-row>
    <v-col cols="12" md="8" lg="6" offset-lg="3" offset-md="2">
      <v-card class="elevation-12">
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Новая загрузка реестра</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <v-combobox v-model="form.templateCode" :items="templateCodeOptions" dense label="Тип шаблона"
                        :error-messages="templateCodeErrors"/>
            <v-file-input v-model="form.file"
                          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          :show-size="true"
                          label="Выбрать файл"
                          @blur="$v.form.file.$touch()"
                          :error-messages="fileErrors"
            />
            <v-textarea v-model="form.note" label="Заметка" filled :auto-grow="true" @blur="$v.form.note.$touch()"/>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" :to="{name: 'web-client-dashboard'}" text>Назад</v-btn>
          <v-spacer/>
          <v-btn color="success" :disabled="$v.form.$invalid" @click="onImportButtonClicked">Импортировать</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import {required} from 'vuelidate/lib/validators'
import XLSX from "xlsx";
import _ from 'underscore'
import RegistryService from '@/services/registry.service'
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import Mappers from "@/mappers";

export default {
  name: "ImportRegistryView",
  data() {
    return {
      form: {
        note: '',
        file: null,
        templateCode: null,
      },
      templateCodeOptions: [
        {id: 1, text: "Уведомление - 1"},
        {id: 2, text: "Уведомление - 2"}
      ]
    }
  },
  validations: {
    form: {
      file: {
        required: required
      },
      templateCode: {
        required
      },
      note: {}
    }
  },
  computed: {
    fileErrors() {
      const errors = []

      if (this.$v.form.file.$dirty) {
        if (!this.$v.form.file.required)
          errors.push('Выберите файл для импортирования')
      }

      return errors
    },
    templateCodeErrors() {
      const errors = []

      if (this.$v.form.templateCode.$dirty) {
        if (!this.$v.form.templateCode.required)
          errors.push('Выберите тип шаблона')
      }

      return errors
    }
  },
  methods: {
    onImportButtonClicked() {
      this.$store.dispatch(LAYOUT_LOADING_START)
      const reader = new FileReader();

      reader.onload = (e) => {
        const xlsx = XLSX.read(e.target.result, {type: 'binary', cellDates: true, cellNF: false, cellText: false});
        const firstSheet = xlsx.Sheets[xlsx.SheetNames[0]]
        const firstSheetData = XLSX.utils.sheet_to_json(firstSheet, {dateNF: 'dd"."mm"."yyyy', raw: false})

        const keys = Object.keys(firstSheetData[0])
        let requestContent = {
          Note: this.form.note,
          TemplateCode: this.form.templateCode.id
        };

        if (this.form.templateCode.id === 1) {
          const regionNameColumnIndex = 0
          const rotsNameRodPadejColumnIndex = 1
          const rotsNameUzbColumnIndex = 2
          const rotsDirectorColumnIndex = 3
          const rotsPhoneColumnIndex = 4
          const accountNumberColumnIndex = 5
          const addressColumnIndex = 6
          const checkEndDateColumnIndex = 7
          const receiverNameColumnIndex = 8
          const regionColumnIndex = 9
          const areaColumnIndex = 10

          requestContent.Mails = _.map(firstSheetData, row => {
            return {
              Receiver: row[keys[receiverNameColumnIndex]],
              Address: row[keys[addressColumnIndex]],
              Region: row[keys[regionColumnIndex]],
              Area: row[keys[areaColumnIndex]],
              Content: {
                region_name: row[keys[regionNameColumnIndex]],
                rots_name_rod_padej: row[keys[rotsNameRodPadejColumnIndex]],
                rots_name_uzb: row[keys[rotsNameUzbColumnIndex]],
                director: row[keys[rotsDirectorColumnIndex]],
                rots_phone: row[keys[rotsPhoneColumnIndex]],
                account_number: row[keys[accountNumberColumnIndex]],
                address: row[keys[addressColumnIndex]],
                check_end_date: row[keys[checkEndDateColumnIndex]],
                receiver_name: row[keys[receiverNameColumnIndex]],
              }
            }
          })
        } else if (this.form.templateCode.id === 2) {
          const regionNameColumnIndex = 0
          const rotsNameRodPadejColumnIndex = 1
          const rotsNameUzbColumnIndex = 2
          const rotsDirectorColumnIndex = 3
          const rotsPhoneColumnIndex = 4
          const accountNumberColumnIndex = 5
          const addressColumnIndex = 6
          const debtOnColumnIndex = 7
          const debtAmountColumnIndex = 8
          const penaltyAmountColumnIndex = 9
          const receiverNameColumnIndex = 10
          const regionColumnIndex = 11
          const areaColumnIndex = 12

          requestContent.Mails = _.map(firstSheetData, row => {
            return {
              Receiver: row[keys[receiverNameColumnIndex]],
              Address: row[keys[addressColumnIndex]],
              Region: row[keys[regionColumnIndex]],
              Area: row[keys[areaColumnIndex]],
              Content: {
                region_name: row[keys[regionNameColumnIndex]],
                rots_name_rod_padej: row[keys[rotsNameRodPadejColumnIndex]],
                rots_name_uzb: row[keys[rotsNameUzbColumnIndex]],
                director: row[keys[rotsDirectorColumnIndex]],
                rots_phone: row[keys[rotsPhoneColumnIndex]],
                account_number: row[keys[accountNumberColumnIndex]],
                address: row[keys[addressColumnIndex]],
                receiver_name: row[keys[receiverNameColumnIndex]],
                debt_amount: row[keys[debtAmountColumnIndex]],
                penalty_amount: row[keys[penaltyAmountColumnIndex]],
                debt_on: row[keys[debtOnColumnIndex]]
              }
            }
          })
        }

        RegistryService.create(requestContent)
            .then(response => {
              this.$store.dispatch(LAYOUT_LOADING_STOP)
              const registry = Mappers.mapRegistry(response.data)

              this.$router.push({name: 'web-client-registry', params: {id: registry.id}})
            }, () => {
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            })
      }
      reader.onerror = () => {
        this.$store.dispatch(LAYOUT_LOADING_STOP)
      }
      reader.readAsBinaryString(this.form.file)
    }
  }
}
</script>

<style scoped>

</style>